import { VoidComponent } from "solid-js";
import { TextButton } from "../../../../../../components/button/Button";
import { useTranslation } from "../../../../../../state/i18n";
import { resolveFallbackLanguage } from "../../../../../../utils/languageUtil";

const ContactUsAction: VoidComponent = () => {
  const { t, currentLanguage } = useTranslation();

  const openMeeting = () => {
    window.open(
      `https://links.moreapp.com/meeting/sales/${resolveFallbackLanguage(currentLanguage())}`,
      "_blank",
      "noopener",
    );
  };

  return (
    <TextButton
      text={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_ACTION_CONTACT_US_LABEL)}
      variant="secondary"
      size="medium"
      onClick={openMeeting}
    />
  );
};

export default ContactUsAction;
